import "./saldoCard.css";
import { DateTime } from "luxon";

function SaldoCard({ dados }) {

  const {
    indexsaldo,
    saldo,
    tipo,
    saldoatual,
    valorfatura,
    percentualentrada,
    percentualsaida,
    totalentrada,
    totalsaida,
    dtinicio,
    dtfim
  } = dados;

  const formatar = (valor = 0) =>
    Number(valor).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    });

  const formatarData = (dateStr) => dateStr ? DateTime.fromISO(dateStr).plus({ hours: 3 }).toFormat("dd/MM/yyyy") : "";    

  const ehCartao = indexsaldo === 1;

  const valorPrincipal = ehCartao
    ? valorfatura
    : saldoatual;

  const positivo = Number(saldoatual) >= 0;

  return (
    <div className="saldo-card-item">

      <div className="saldo-left">

        <div className="saldo-icon">
          <img
            src={require(`../../assets/saldos/${indexsaldo + 1}.png`)}
            alt="icone saldo"
          />
        </div>

        <div className="saldo-info">

          <strong>{saldo}</strong>

          <span>{tipo}</span>

          {ehCartao && (
            <small className="saldo-periodo">
              {formatarData(dtinicio)} até {formatarData(dtfim)}
            </small>
          )}

        </div>

      </div>

      <div className="saldo-right">

        <div
          className={`saldo-valor ${
            ehCartao
              ? "fatura"
              : positivo
                ? "positivo"
                : "negativo"
          }`}
        >
          {formatar(valorPrincipal)}
        </div>

        {ehCartao ? (
          <div className="saldo-subinfo">
            Fatura Atual
          </div>
        ) : (
          <div className="saldo-subinfo">
            Saldo Disponível
          </div>
        )}

        <div className="saldo-barra">
          <div
            className="barra-entrada"
            style={{ width: `${percentualentrada || 0}%` }}
          />

          <div
            className="barra-saida"
            style={{ width: `${percentualsaida || 0}%` }}
          />
        </div>

        <div className="saldo-totais">
          <span className="entrada">
            ↑ {formatar(totalentrada)}
          </span>

          <span className="saida">
            ↓ {formatar(totalsaida)}
          </span>
        </div>

      </div>

    </div>
  );
}

export default SaldoCard;